const DimensionDescriptionInstructionsLayout = ({ data }) => {
  return (
    <>
      <div className="h5">{data.lead}</div>
      <div className="h3 mt-4">Indicaciones</div>
      <ol>
        {data.steps.map((step, stepIndex) => (
          <li key={`survey-dimension-instructions-step-${stepIndex}`} className="h5">
            {step["text"]}
          </li>
        ))}
      </ol>
    </>
  );
};

export default DimensionDescriptionInstructionsLayout;
